/**
 * The base request path for the character API for Classic World of Warcraft.
 */
export const characterBase = 'profile/wow/character';
